import React from "react";
import SubscriptionComparison from "@/components/subscription/SubscriptionComparison";
import AuthorSection from "@/components/dashboard/AuthorSection";
import SettingsSection from "@/components/dashboard/SettingsSection";
import IssueSection from "@/components/dashboard/IssueSection";

const MorePage = () => {
  return (
    <div className="p-0 sm:p-6">
      <div className="space-y-8">
        <SubscriptionComparison />
        <AuthorSection />
        <SettingsSection />
        <IssueSection />
      </div>
    </div>
  );
};

export default MorePage;
